import React from 'react'

const BatchProcessingServiceComponent = React.createContext(null)
export default BatchProcessingServiceComponent
